module.exports = __webpack_public_path__ + "img/chinesecompany105.c61a9480.png";